import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import { Close } from '@material-ui/icons';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';

const styles = theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(2),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

const SimpleSnackbar = props => {
  const { classes, message, onClose, snackbarOpen, variant } = props;

  return (
    <Snackbar
      aria-describedby="client-snackbar"
      open={snackbarOpen}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      message={message}
      resumeHideDuration={3000}
      onClose={onClose}
      className={classes[variant]}
      action={[
        <IconButton key="close" aria-label="Close" color="inherit" className={classes.close} onClick={onClose}>
          <Close className={classes.icon} />
        </IconButton>,
      ]}
    />
  );
};

SimpleSnackbar.defaultProps = {
  variant: 'info',
};

SimpleSnackbar.propTypes = {
  classes: PropTypes.object.isRequired,
  snackbarOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.any.isRequired,
  variant: PropTypes.string,
};

export default withStyles(styles)(SimpleSnackbar);
